export default "__VITE_ASSET__aSWHGkPJ__"